/* eslint-disable import/no-unresolved */
import React from 'react'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Divider from '@material-ui/core/Divider'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import Avatar from '@material-ui/core/Avatar'
import LibraryAddIcon from '@material-ui/icons/LibraryAdd'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import SubscriptionsIcon from '@material-ui/icons/Subscriptions'
import Grid from '@material-ui/core/Grid'
import Skeleton from '@material-ui/lab/Skeleton'
import HelpIcon from '@material-ui/icons/Help'
import ListSubheader from '@material-ui/core/ListSubheader'
import IconButton from '@material-ui/core/IconButton'
import moment from 'moment'
import TrendingDownIcon from '@material-ui/icons/TrendingDown'
import TrendingUpIcon from '@material-ui/icons/TrendingUp'
import TransformIcon from '@material-ui/icons/Transform'
import AddToListModal from 'src/components/insigth/YoutubeAddList'
import SearchBar from 'src/components/insigth/SearchBar'
import { useStyles } from './styles'

const YoutubePage = ({
  setOpenAddToList,
  openAddToList,
  handleSearchList,
  handleSelectList,
  handleCreateList,
  onChange,
  loading,
  searchList,
  creatList,
  list,
}) => {
  const classes = useStyles()

  return (
    <>
      {openAddToList && (
        <AddToListModal
          onChange={onChange}
          loading={loading}
          creatList={creatList}
          handleCreateList={handleCreateList}
          onClose={() => setOpenAddToList(false)}
          openAddToList={openAddToList}
        />
      )}
      <h3 className={classes.h3}>Lista de Videos</h3>
      <List component="div" key="key" className={classes.root}>
        <ListSubheader>
          <br />
          <Grid container spacing={2}>
            <Grid item sm={7} xs={7}>
              <button
                type="button"
                className={classes.colorLink}
                onClick={() => setOpenAddToList(true)}
              >
                <Grid container spacing={2}>
                  <Grid item sm={2} xs={2}>
                    <LibraryAddIcon style={{ fontSize: 25 }} />
                  </Grid>
                  <Grid item sm={10} xs={10}>
                    <p>Nuevo conjunto de análisis</p>
                  </Grid>
                </Grid>
              </button>
            </Grid>
          </Grid>
          <SearchBar
            videos=""
            search={searchList}
            handleSearch={handleSearchList}
          />
        </ListSubheader>
        <br />
        {!loading ? (
          list.length > 0 ? (
            list.map((item) => (
              <div key={item._id}>
                <ListItem
                  button
                  role={undefined}
                  dense
                  alignItems="flex-start"
                  style={{paddingBottom: '50px'}}
                  onClick={() => handleSelectList({ ...item })}
                >
                  <ListItemAvatar>
                    <Avatar alt={item.nombre.toUpperCase()}>
                      {item.nombre.charAt(0).toUpperCase()}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={item.nombre.toUpperCase()}
                  />
                  <ListItem component='span' className={classes.gridContainer} >
                    <Grid container className={classes.gridItemsContainer}>
                      <Grid item sm={4}>
                          {`Creado: ${moment(item?.creacion || 0).format(
                            'll',
                          )}`}
                          <br />
                          {`Descripción: ${item?.descripcion || 0}`}
                          <br />
                          {`Numero de análisis: ${item?.analisis?.length || 0}`}
                          <br />
                      </Grid>
                      <Grid item sm={4}>
                        <TrendingUpIcon
                          style={{ fontSize: '15px', color: 'green' }}
                        />{' '}
                        {`Positivos: ${item?.calculo?.sum || 0}`}
                        <br />
                        <TrendingDownIcon
                          style={{ fontSize: '15px', color: 'red' }}
                        />{' '}
                        {`Negativos: ${item?.calculo?.res || 0}`}
                        <br />
                        <TransformIcon
                          style={{ fontSize: '15px', color: '#F6BE00' }}
                        />{' '}
                        {`Neutros: ${item?.calculo?.neutro || 0}`}
                      </Grid>
                      <Grid item sm={4}>
                        {`Mágnitud: ${item?.calculo?.tMagnitude?.toFixed(3) || 0 }`}
                        <br />
                        {`Score: ${item?.calculo?.tScore?.toFixed(3) || 0}`}
                        <br />
                        {`Total Sentimientos: ${
                          item?.calculo?.sum +
                          item?.calculo?.res +
                          item?.calculo?.neutro || 0
                          }`}
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItemSecondaryAction>
                    <IconButton
                      onClick={() => handleSelectList({ ...item })}
                      edge="end"
                      aria-label="youTube"
                    >
                      <SubscriptionsIcon
                        fontSize="large"
                        style={{ color: '#F70000' }}
                      />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
                <Divider variant="inset" component="li" />
              </div>
            ))
          ) : (
            <ListItem alignItems="flex-start">
              <ListItemAvatar>
                <HelpIcon style={{ color: '#F70000' }} alt="No - " />
              </ListItemAvatar>
              <ListItemText primary="No se encuentran coincidencias" />
            </ListItem>
          )
        ) : (
          <div style={{ margin: '10px' }}>
            <Skeleton />
            <Skeleton animation={false} />
            <Skeleton animation="wave" />
            <Skeleton />
            <Skeleton />
            <Skeleton animation="wave" />
            <Skeleton />
            <Skeleton animation={false} />
            <Skeleton animation="wave" />
          </div>
        )}
      </List>
    </>
  )
}

export default YoutubePage
